import React from 'react'
import T from 'prop-types'

import BEMHelper from '../../helpers/bem'
import styles from './Styles.module.scss'
import Image from '../Image'

const bem = new BEMHelper(styles)

export default function Employees({ title, list, muted }) {
  return (
    <section {...bem('', { muted })}>
      {title && <h2 {...bem('title')}>{title}</h2>}

      {list && (
        <ul {...bem('list')}>
          {list.map(({ _id, title, image, role, email, details, workTitle }) => (
            <li key={_id} {...bem('item')}>
              {!muted && <Image {...image} width={750} height={750} alt=""/>}

              <div {...bem('info')}>
                <div {...bem('details')}>
                  <h3 {...bem('name')}>{title}</h3>
                  <span>{role}</span>
                  <span>{workTitle}</span>
                  <a href={`mailto:${email}`}>{email}</a>
                </div>

                <p>{details}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}

Employees.propTypes = {
  title: T.string,
  list: T.array,
  muted: T.bool,
}
